import { api } from '@/services';
import type {
  DadosEmpresaResponse,
  UsuariosResponse,
  ParametroFederalResponse,
  ParametroFederalApi,
  RegrasICMSResponse,
  RegraDeParaICMSApi,
  RegrasIBSCBSResponse,
  RegraDeParaIBSCBSApi,
  RegrasIbsCbsEntradaResponse,
  ImportacaoConteudoFiscalApi,
  ImportacaoConteudoFiscalResponse,
  CertificadosResponse,
  CertificadoAtivoApi,
  AuditoriaResponse,
  ConfiguracoesStatusResponse,
  AtualizarUsuarioApi,
  CriarUsuarioApi,
} from '../types';

const BASE = 'TurboPro/Configuracoes';

export const fetchDadosEmpresa = () => api.get<DadosEmpresaResponse>(`${BASE}/DadosEmpresa`);

export const atualizarDadosEmpresa = () =>
  api.post<DadosEmpresaResponse>(`${BASE}/DadosEmpresa/Atualizar`);

export const atualizarCertificadoAtivo = (model: CertificadoAtivoApi) =>
  api.post<ConfiguracoesStatusResponse, CertificadoAtivoApi>(`${BASE}/Certificados/Ativo`, model);

export const adicionarCertificado = (file: File, senha: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('senha-certificado', senha);
  return api.upload<ConfiguracoesStatusResponse>('Arquivo/UploadCertificado', formData);
};

export const fetchUsuarios = () => api.get<UsuariosResponse>(`${BASE}/Usuarios`);

export const atualizarUsuario = (model: AtualizarUsuarioApi) =>
  api.post<ConfiguracoesStatusResponse, AtualizarUsuarioApi>(`${BASE}/Usuarios/Atualizar`, model);

export const excluirUsuario = (email: string) =>
  api.delete<ConfiguracoesStatusResponse>(`${BASE}/Usuarios/${encodeURIComponent(email)}`);

export const criarUsuario = (model: CriarUsuarioApi) =>
  api.post<ConfiguracoesStatusResponse, CriarUsuarioApi>(
    'Usuario/CreateUsuarioGestorCompleto',
    model
  );

export const fetchParametroFederal = () =>
  api.get<ParametroFederalResponse>(`${BASE}/ParametroFederal`);

export const salvarParametroFederal = (model: Partial<ParametroFederalApi>) =>
  api.post<ConfiguracoesStatusResponse, Partial<ParametroFederalApi>>(
    `${BASE}/ParametroFederal`,
    model
  );

export const fetchRegrasICMS = () => api.get<RegrasICMSResponse>(`${BASE}/RegraDeParaICMS`);

export const salvarRegraICMS = (model: Partial<RegraDeParaICMSApi>) =>
  api.post<ConfiguracoesStatusResponse, Partial<RegraDeParaICMSApi>>(
    `${BASE}/RegraDeParaICMS`,
    model
  );

export const excluirRegraICMS = (id: number) =>
  api.delete<ConfiguracoesStatusResponse>(`${BASE}/RegraDeParaICMS/${id}`);

export const importarRegrasICMS = (regras: Partial<RegraDeParaICMSApi>[]) =>
  api.post<ConfiguracoesStatusResponse, Partial<RegraDeParaICMSApi>[]>(
    `${BASE}/RegraDeParaICMS/Importar`,
    regras
  );

export const fetchRegrasIBSCBS = () => api.get<RegrasIBSCBSResponse>(`${BASE}/RegraDeParaIBSCBS`);

export const salvarRegraIBSCBS = (model: Partial<RegraDeParaIBSCBSApi>) =>
  api.post<ConfiguracoesStatusResponse, Partial<RegraDeParaIBSCBSApi>>(
    `${BASE}/RegraDeParaIBSCBS`,
    model
  );

export const excluirRegraIBSCBS = (id: number) =>
  api.delete<ConfiguracoesStatusResponse>(`${BASE}/RegraDeParaIBSCBS/${id}`);

export const fetchCertificados = () => api.get<CertificadosResponse>(`${BASE}/Certificados`);

export const fetchAuditoria = () => api.get<AuditoriaResponse>(`${BASE}/Auditoria`);
export const importarRegrasIBSCBS = (regras: Partial<RegraDeParaIBSCBSApi>[]) =>
  api.post<ConfiguracoesStatusResponse, Partial<RegraDeParaIBSCBSApi>[]>(
    `${BASE}/RegraDeParaIBSCBS/Importar`,
    regras
  );

export const fetchRegrasIbsCbsEntrada = () =>
  api.get<RegrasIbsCbsEntradaResponse>(`${BASE}/RegrasIbsCbsEntrada`);

export const importarConteudoFiscalIbsCbs = (arquivo: ImportacaoConteudoFiscalApi) =>
  api.post<ImportacaoConteudoFiscalResponse, ImportacaoConteudoFiscalApi>(
    `${BASE}/RegraDeParaIBSCBS/ImportarConteudoFiscal`,
    arquivo
  );
